<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link :to="{ path: '/mapaCotacao', query: $route.query }">
        Compras/ Mapa de Compra
      </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <v-container fluid>
      <div class="mapa-cotacao-toolbar">
        <div class="mapa-cotacao-actions">
          <v-btn
              @click="abrirEmail()"
              :disabled="read_only"
              class="blue--text"
            >
              <v-icon>mdi-email</v-icon>
              Enviar Email
            </v-btn>
          <v-btn
              color="info"
              class="white--text"
              @click="addProduto()"
              :disabled="read_only"
            >
              <v-icon left>mdi-plus</v-icon>
              Adicionar produto
            </v-btn>
          <v-btn
              color="info"
              class="white--text"
              @click="addFornecedor()"
              :disabled="read_only"
            >
              <v-icon left>mdi-plus</v-icon>
              Adicionar Fornecedor
            </v-btn>
          <v-btn
              @click="exportarExcel()"
              class="blue--text"
              :disabled="produtosL.length <= 0"
            >
              <v-icon>mdi-file-excel</v-icon>
              Gerar Arquivo Excel
            </v-btn>
        </div>
        <mapa-cotacao-zoom-controls
          :value="mapaCotacaoZoom"
          :min="mapaCotacaoZoomMin"
          :max="mapaCotacaoZoomMax"
          :default-value="mapaCotacaoZoomDefault"
          @decrease="diminuirZoomMapa"
          @increase="aumentarZoomMapa"
          @reset="restaurarZoomMapa"
        />
      </div>
      <v-divider class="my-4"></v-divider>
      <div class="mobile-toggle-produtos">
        <v-btn
          block
          outlined
          color="primary"
          @click="produtosVisiveisMobile = !produtosVisiveisMobile"
        >
          {{ produtosVisiveisMobile ? "Ocultar produtos" : "Mostrar produtos" }}
        </v-btn>
      </div>
      <v-form ref="form" v-model="valid" lazy-validation :readonly="read_only">
        <div :class="['mapa-mobile-layout', 'mapa-cotacao-zoom-area', mapaCotacaoZoomClass]">
          <section class="mapa-mobile-section" v-show="produtosVisiveisMobile">
            <div class="mapa-mobile-section-title">Produtos</div>
            <div v-if="!produtosL.length" class="mapa-mobile-value">Nenhum produto selecionado.</div>
            <div v-for="(produto, pi) in produtosL" :key="'mobile_produto_' + produto.idSolicitacaoItem" class="mapa-produto-card">
              <div class="mapa-produto-title">{{ produto.produto }}</div>
              <div class="mapa-product-grid">
                <div><div class="mapa-mobile-label">Quantidade</div><div class="mapa-mobile-value">{{ produto.quantidadeAutorizado }}</div></div>
                <div><div class="mapa-mobile-label">Código</div><div class="mapa-mobile-value">{{ produto.codigo }}</div></div>
                <div><div class="mapa-mobile-label">Unidade</div><div class="mapa-mobile-value">{{ produto.unidadeMedida }}</div></div>
                <div><div class="mapa-mobile-label">Centro Custo</div><div class="mapa-mobile-value">{{ produto.centroCusto }}</div></div>
                <div><div class="mapa-mobile-label">Obra</div><div class="mapa-mobile-value">{{ produto.unidadeAdm }}</div></div>
                <div><div class="mapa-mobile-label">Departamento</div><div class="mapa-mobile-value">{{ produto.departamento }}</div></div>
              </div>
              <!--<div class="mapa-card-actions" v-if="!read_only">
                <v-btn small color="error" outlined @click="removerProduto(pi)"><v-icon left small>mdi-delete</v-icon>Remover</v-btn>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <v-btn small color="warning" outlined :disabled="produto.possuiPedidoAtivo" @click="abrirModalInativarProduto(pi)"><v-icon left small>mdi-cancel</v-icon>Inativar</v-btn>
                    </span>
                  </template>
                  <span>{{ produto.possuiPedidoAtivo ? "Item possui Pedido de Compra ativo" : "Inativar item na origem" }}</span>
                </v-tooltip>
              </div>-->
            </div>
          </section>

          <section class="mapa-info-mobile">
            <div class="mapa-mobile-section-title">MC nº {{ mapaCotacao.id }}</div>
            <v-textarea v-model="informacoesAdicionais" v-uppercase label="Informações adicionais" outlined dense />
          </section>

          <section v-for="(f, j) in fornecedorL" :key="'mobile_fornecedor_' + f.idFornecedor" class="mapa-fornecedor-card">
            <div class="mapa-fornecedor-title">Cotação {{ j + 1 }} - {{ f.nome }}</div>
            <div class="mapa-card-actions" v-if="!read_only">
              <v-btn small color="error" outlined @click="excluirFornecedor(j)"><v-icon left small>mdi-delete</v-icon>Remover fornecedor</v-btn>
            </div>
            <div class="mapa-field-grid">
              <v-text-field v-model="f.nomeOrcamento" label="Nº do orçamento" dense outlined :rules="[(v) => !!v || 'O número do orçamento é obrigatório']" required />
              <v-select v-model="f.idCondicaoPagamento" :items="condicoes" item-value="id" item-text="descricao" label="Pagamento" dense outlined :rules="[(v) => !!v || 'A condição de pagamento é obrigatória']" required />
              <v-checkbox v-model="f.coleta" @click.native.stop.prevent="changeLocal(f.idFornecedor)" label="Coleta"></v-checkbox>
              <v-select v-if="!f.coleta" v-model="f.idLocalEntrega" :items="locais" item-value="id" :item-text="formatarLocal" label="Local Entrega" dense outlined />
              <v-text-field v-else v-model="f.enderecoColeta" v-uppercase label="Endereço de coleta" dense outlined />
            </div>
            <div v-for="produto in produtosL" :key="'mobile_item_' + f.idFornecedor + '_' + produto.idSolicitacaoItem" class="mapa-item-card">
              <div class="mapa-item-title">{{ produto.produto }}</div>
              <div class="mapa-item-grid">
                <div><div class="mapa-mobile-label">Qtd solicitada</div><div class="mapa-mobile-value">{{ produto.quantidadeAutorizado }}</div></div>
                <v-text-field v-model.number="getItem(f.idFornecedor, produto.idSolicitacaoItem, produto.idProduto).prazo" dense outlined type="number" label="Prazo" :rules="[rules.naoNegativo]" />
                <v-text-field v-model="getItem(f.idFornecedor, produto.idSolicitacaoItem, produto.idProduto).marca" dense outlined label="Marca" />
                <v-text-field v-model.number="getItem(f.idFornecedor, produto.idSolicitacaoItem, produto.idProduto).quantidade" @input="calcularTotais(f.idFornecedor, produto.idSolicitacaoItem)" dense outlined type="number" label="Quantidade" :rules="[rules.naoNegativo]" />
                <v-text-field :value="formatarDecimal4(getItem(f.idFornecedor, produto.idSolicitacaoItem, produto.idProduto).valor)" @input="(valor) => atualizarDecimalItem(valor, getItem(f.idFornecedor, produto.idSolicitacaoItem, produto.idProduto), 'valor', f.idFornecedor, produto.idSolicitacaoItem)" dense outlined inputmode="numeric" label="Valor unitário" @focus="posicionarCursorFim" @click="posicionarCursorFim" :rules="[rules.naoNegativo]" />
                <v-text-field :value="formatarDecimal4(getItem(f.idFornecedor, produto.idSolicitacaoItem, produto.idProduto).descontoProduto)" @input="(valor) => atualizarDecimalItem(valor, getItem(f.idFornecedor, produto.idSolicitacaoItem, produto.idProduto), 'descontoProduto', f.idFornecedor, produto.idSolicitacaoItem)" dense outlined inputmode="numeric" label="Desconto" @focus="posicionarCursorFim" @click="posicionarCursorFim" :rules="[rules.naoNegativo]" />
                <v-text-field :value="formatarDecimal4(getItem(f.idFornecedor, produto.idSolicitacaoItem).total)" readonly dense outlined label="Total" />
                <v-checkbox v-model="getItem(f.idFornecedor, produto.idSolicitacaoItem, produto.idProduto).comprar" dense hide-details :true-value="true" :false-value="false" color="primary" label="Comprar" @change="(val) => val ? marcarCompraExclusiva(f.idFornecedor, produto.idSolicitacaoItem, produto.quantidadeAutorizado) : null" />
              </div>
            </div>
            <div class="mapa-totais-mobile"><div class="mapa-totais-grid">
              <v-text-field :value="formatarDecimal4(calcularTotalOrcamento(f.idFornecedor))" readonly dense outlined label="Total do orçamento" />
              <v-text-field :value="formatarDecimal4(calcularSubtotal(f.idFornecedor))" readonly dense outlined label="Subtotal" />
              <v-text-field :value="formatarDecimal4(f.acrescimo)" label="Acréscimo" dense outlined inputmode="numeric" @focus="posicionarCursorFim" @click="posicionarCursorFim" @input="(valor) => atualizarDecimalFornecedor(valor, f, 'acrescimo')" :rules="[rules.naoNegativo]" />
              <v-text-field :value="formatarDecimal4(f.descontoTotal)" label="Desconto" dense outlined inputmode="numeric" @focus="posicionarCursorFim" @click="posicionarCursorFim" @input="(valor) => atualizarDecimalFornecedor(valor, f, 'descontoTotal')" :rules="[rules.naoNegativo]" />
              <v-text-field :value="formatarDecimal4(calcularTotalFinal(f.idFornecedor))" readonly dense outlined label="Total" />
              <v-textarea v-model="f.observacao" v-uppercase label="Observação" dense outlined rows="3" />
            </div></div>
          </section>
        </div>
        <div
          :class="['mapa-cotacao-zoom-area', 'cotacao-tabela-container cotacao-desktop-wrapper', mapaCotacaoZoomClass]"
        >
          <v-simple-table class="cotacao-tabela">
            <thead>
              <tr>
                <th class="fixed-column"></th>
                <th
                  v-for="(f, i) in fornecedorL"
                  :key="f.idFornecedor"
                  class="cotacao-cabecalho"
                >
                  Cotação {{ i + 1 }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="linha-reduzida">
                <td class="fixed-column">
                  <v-divider class="my-4"></v-divider>
                  <h2 class="display-1 font-weight-bold mb-4">
                    MC nº {{ mapaCotacao.id }}
                  </h2>
                  <v-textarea
                    v-model="informacoesAdicionais" v-uppercase
                    label="Informações adicionais"
                    outlined
                    dense
                  />
                </td>
                <td v-for="(f, j) in fornecedorL" :key="f.idFornecedor">
                  <div class="d-flex align-center justify-space-between">
                    <div class="fornecedor-nome">{{ f.nome }}</div>
                    <v-btn v-if="!read_only" icon @click="excluirFornecedor(j)">
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                  <v-text-field
                    v-model="f.nomeOrcamento"
                    label="Nº do orçamento"
                    dense
                    outlined
                    :rules="[
                      (v) => !!v || 'O número do orçamento é obrigatório',
                    ]"
                    required
                  />
                  <v-select
                    v-model="f.idCondicaoPagamento"
                    :items="condicoes"
                    item-value="id"
                    item-text="descricao"
                    label="Pagamento"
                    dense
                    outlined
                    :rules="[
                      (v) => !!v || 'A condição de pagamento é obrigatória',
                    ]"
                    required
                  /><v-checkbox
                    v-model="f.coleta"
                    @click.native.stop.prevent="changeLocal(f.idFornecedor)"
                    label="Coleta"
                  ></v-checkbox>
                  <v-select
                    v-if="!f.coleta"
                    v-model="f.idLocalEntrega"
                    :items="locais"
                    item-value="id"
                    :item-text="formatarLocal"
                    label="Local Entrega"
                    dense
                    outlined
                  />
                  <v-text-field
                    v-else
                    v-model="f.enderecoColeta" v-uppercase
                    label="Endereço de coleta"
                    dense
                    outlined
                  />
                </td>
              </tr>

              <tr>
                <td class="fixed-column">
                  <div style="overflow-x: auto; white-space: nowrap">
                    <v-simple-table
                      v-resizable-columns
                      dense
                      class="produto-table"
                    >
                      <thead>
                        <tr class="produto-cabecalho">
                          <th v-if="!read_only"></th>
                          <th>Qtd</th>
                          <th>Produto</th>
                          <th>Código</th>
                          <th>Un</th>
                          <th>Centro Custo</th>
                          <th>Obra</th>
                          <th>Dpto</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(produto, pi) in produtosL"
                          :key="produto.idSolicitacaoItem"
                          :class="pi % 2 === 0 ? 'linha-par' : 'linha-impar'"
                        >
                          <td v-if="!read_only">
                            <v-btn icon small @click="removerProduto(pi)">
                              <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                            <!--<v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on">
                                  <v-btn icon small :disabled="produto.possuiPedidoAtivo" @click="abrirModalInativarProduto(pi)">
                                    <v-icon color="orange">mdi-cancel</v-icon>
                                  </v-btn>
                                </span>
                              </template>
                              <span>{{ produto.possuiPedidoAtivo ? "Item possui Pedido de Compra ativo" : "Inativar item na origem" }}</span>
                            </v-tooltip>-->
                          </td>
                          <td>{{ produto.quantidadeAutorizado }}</td>
                          <td>{{ produto.produto }}</td>
                          <td>{{ produto.codigo }}</td>
                          <td>{{ produto.unidadeMedida }}</td>
                          <td>{{ produto.centroCusto }}</td>
                          <td>{{ produto.unidadeAdm }}</td>
                          <td>{{ produto.departamento }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </div>
                </td>
                <td
                  v-for="f in fornecedorL"
                  :key="f.idFornecedor"
                  class="col-fornecedor"
                >
                  <v-simple-table
                    v-resizable-columns
                    dense
                    class="fornecedor-inner-table"
                  >
                    <thead>
                      <tr class="produto-cabecalho">
                        <th class="column-prazo">Prazo</th>
                        <th class="column-marca">Marca</th>
                        <th class="column-quantidade">Qtd</th>
                        <th class="column-vr-unit">Vr. Unit</th>
                        <th class="column-desc">Desc</th>
                        <th class="column-total">Total.</th>
                        <th class="column-checkbox">...</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(produto, pi) in produtosL"
                        :key="
                          'input_' +
                          f.idFornecedor +
                          '_' +
                          produto.idSolicitacaoItem
                        "
                        :class="pi % 2 === 0 ? 'linha-par' : 'linha-impar'"
                      >
                        <td>
                          <v-text-field
                            v-model.number="
                              getItem(
                                f.idFornecedor,
                                produto.idSolicitacaoItem,
                                produto.idProduto
                              ).prazo
                            "
                            dense
                            hide-details
                            class="compact-input"
                            type="number"
                            :rules="[rules.naoNegativo]"
                          />
                        </td>
                        <td>
                          <v-text-field
                            v-model="
                              getItem(
                                f.idFornecedor,
                                produto.idSolicitacaoItem,
                                produto.idProduto
                              ).marca
                            "
                            dense
                            hide-details
                            class="compact-input"
                          />
                        </td>
                        <td>
                          <v-text-field
                            v-model.number="
                              getItem(
                                f.idFornecedor,
                                produto.idSolicitacaoItem,
                                produto.idProduto
                              ).quantidade
                            "
                            @input="
                              calcularTotais(
                                f.idFornecedor,
                                produto.idSolicitacaoItem
                              )
                            "
                            dense
                            hide-details
                            class="compact-input"
                            type="number"
                            :rules="[rules.naoNegativo]"
                          />
                        </td>
                        <td>
                          <v-text-field
                            :value="
                              formatarDecimal4(
                                getItem(
                                  f.idFornecedor,
                                  produto.idSolicitacaoItem,
                                  produto.idProduto
                                ).valor
                              )
                            "
                            @input="
                              (valor) =>
                                atualizarDecimalItem(
                                  valor,
                                  getItem(
                                    f.idFornecedor,
                                    produto.idSolicitacaoItem,
                                    produto.idProduto
                                  ),
                                  'valor',
                                  f.idFornecedor,
                                  produto.idSolicitacaoItem
                                )
                            "
                            dense
                            hide-details
                            class="compact-input"
                            inputmode="numeric"
                            @focus="posicionarCursorFim"
                            @click="posicionarCursorFim"
                            :rules="[rules.naoNegativo]"
                          />
                        </td>
                        <td>
                          <v-text-field
                            :value="
                              formatarDecimal4(
                                getItem(
                                  f.idFornecedor,
                                  produto.idSolicitacaoItem,
                                  produto.idProduto
                                ).descontoProduto
                              )
                            "
                            @input="
                              (valor) =>
                                atualizarDecimalItem(
                                  valor,
                                  getItem(
                                    f.idFornecedor,
                                    produto.idSolicitacaoItem,
                                    produto.idProduto
                                  ),
                                  'descontoProduto',
                                  f.idFornecedor,
                                  produto.idSolicitacaoItem
                                )
                            "
                            dense
                            hide-details
                            class="compact-input"
                            inputmode="numeric"
                            @focus="posicionarCursorFim"
                            @click="posicionarCursorFim"
                            :rules="[rules.naoNegativo]"
                          />
                        </td>
                        <td>
                          <v-text-field
                            :value="
                              formatarDecimal4(
                                getItem(
                                  f.idFornecedor,
                                  produto.idSolicitacaoItem
                                ).total
                              )
                            "
                            readonly
                            dense
                            hide-details
                            class="compact-input"
                          />
                        </td>
                        <td class="checkbox-cell">
                          <v-checkbox
                            v-model="
                              getItem(
                                f.idFornecedor,
                                produto.idSolicitacaoItem,
                                produto.idProduto
                              ).comprar
                            "
                            dense
                            hide-details
                            :true-value="true"
                            :false-value="false"
                            color="primary"
                            @change="
                              (val) =>
                                val
                                  ? marcarCompraExclusiva(
                                      f.idFornecedor,
                                      produto.idSolicitacaoItem,
                                      produto.quantidadeAutorizado
                                    )
                                  : null
                            "
                            class="align-checkbox"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </td>
              </tr>

              <tr class="linha-reduzida">
                <td class="fixed-column"></td>
                <td v-for="f in fornecedorL" :key="'totais_' + f.idFornecedor">
                  <div>
                    Total do Orçamento:
                    <v-text-field
                      :value="
                        formatarDecimal4(calcularTotalOrcamento(f.idFornecedor))
                      "
                      readonly
                      dense
                    />
                  </div>
                  <div>
                    Subtotal:
                    <v-text-field
                      :value="formatarDecimal4(calcularSubtotal(f.idFornecedor))"
                      readonly
                      dense
                    />
                  </div>
                  <v-text-field
                    :value="formatarDecimal4(f.acrescimo)"
                    label="Acréscimo"
                    dense
                    outlined
                    inputmode="numeric"
                    @focus="posicionarCursorFim"
                    @click="posicionarCursorFim"
                    @input="
                      (valor) =>
                        atualizarDecimalFornecedor(valor, f, 'acrescimo')
                    "
                    :rules="[rules.naoNegativo]"
                  />
                  <v-text-field
                    :value="formatarDecimal4(f.descontoTotal)"
                    label="Desconto"
                    dense
                    outlined
                    inputmode="numeric"
                    @focus="posicionarCursorFim"
                    @click="posicionarCursorFim"
                    @input="
                      (valor) =>
                        atualizarDecimalFornecedor(valor, f, 'descontoTotal')
                    "
                    :rules="[rules.naoNegativo]"
                  />
                  <div>
                    Total:
                    <v-text-field
                      :value="formatarDecimal4(calcularTotalFinal(f.idFornecedor))"
                      readonly
                      dense
                    />
                  </div>
                  <v-textarea
                    v-model="f.observacao" v-uppercase
                    label="Observação"
                    dense
                    outlined
                    rows="2"
                  />
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-form>

      <v-divider class="my-4"></v-divider>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn
            @click="gerarPedido"
            color="primary"
            :disabled="!podeGerarPedido"
            class="mr-4"
            v-if="!read_only || mapaCotacao.status == 'AG'"
          >
            Gerar Pedido
          </v-btn>
          <v-btn
            :to="{ path: '/mapaCotacao', query: $route.query }"
            color="error"
            class="mr-4"
            v-if="!status_pedido"
          >
            Voltar
          </v-btn>
          <v-btn
            :to="{ path: '/mapaCotacao', query: $route.query }"
            color="success"
            class="mr-4"
            v-else
          >
            Voltar
          </v-btn>
          <v-btn
            @click="enviar"
            color="success"
            :disabled="produtosL.length <= 0 && fornecedorL.length <= 0"
            class="mr-4"
            v-if="!read_only"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
    <v-dialog v-model="showModalProduto" max-width="1440" content-class="mapa-cotacao-dialog" persistent>
      <v-card class="mapa-cotacao-modal-card">
        <v-card-title class="headline mapa-cotacao-modal-title"> Adicionar produto </v-card-title>
        <v-card-text class="mapa-cotacao-modal-body">
          <solicitacao
            ref="prdAdd"
            :produtosL="produtosL"
            :showModal="showModalProduto"
          />
        </v-card-text>
        <v-card-actions class="mapa-cotacao-modal-actions">
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-4" @click="showModalProduto = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalInativarItem" max-width="640" persistent>
      <v-card>
        <v-card-title class="headline">Inativar item do Mapa</v-card-title>
        <v-card-text>
          <div class="mb-3">
            {{ produtoInativacao ? produtoInativacao.produto : "" }}
          </div>
          <v-textarea
            v-model="justificativaInativacaoItem"
            label="Justificativa"
            outlined
            dense
            rows="4"
            :rules="[(v) => !!(v && v.trim()) || 'A justificativa é obrigatória']"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" class="mr-4" @click="fecharModalInativarItem">Cancelar</v-btn>
          <v-btn color="warning" class="white--text" @click="confirmarInativarItem">Inativar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalFornecedor" max-width="1180" content-class="mapa-cotacao-dialog">
      <v-card class="mapa-cotacao-modal-card">
        <v-card-title class="headline mapa-cotacao-modal-title">
          Adicionar Fornecedor
          <v-spacer />
          <v-btn
            color="info"
            @click="abrirCadastroProduto"
            v-if="isAllowed(3)"
            class="ma-2 white--text"
          >
            NOVO FORNECEDOR
          </v-btn>
        </v-card-title>
        <v-card-text class="mapa-cotacao-modal-body">
          <fornecedor
            ref="fornecedorAdd"
            :fornecedorL="fornecedorL"
            :showModal="showModalFornecedor"
            @editar-fornecedor="editFornecedor"
          />
        </v-card-text>
        <v-card-actions class="mapa-cotacao-modal-actions">
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="mr-4"
            @click="showModalFornecedor = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalCadastroFornecedor" max-width="100%" persistent>
      <v-card>
        <v-card-title>Cadastrar Novo Fornecedor</v-card-title>
        <v-card-text>
          <cadastro-fornecedor
            :on-cancelar="() => (showModalCadastroFornecedor = false)"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showModalEditaFornecedor" max-width="100%" persistent>
      <v-card>
        <v-card-title>Editar Novo Fornecedor</v-card-title>
        <v-card-text>
          <template v-if="showModalEditaFornecedor && this.fornecedor">
            <edita-fornecedor
              :key="this.fornecedor.id || Math.random()"
              :on-cancelar="() => (showModalEditaFornecedor = false)"
            />
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <email-composer
      :show="showEmailModal"
      :attachedFile="{
        name: 'Cotacao Nº' + this.mapaCotacao.id + '.xlsx',
        blob: this.anexaExcel(),
      }"
      :produtos="produtosL"
      :fornecedores="fornecedorL"
      :numeroCotacao="mapaCotacao.id"
      @cancel="showEmailModal = false"
      @send="enviarEmail"
    />
  </div>
</template>

<script>
import {
  atualizarMapaCotacaoAsync,
  inativarItemMapaCotacaoAsync,
  gerarPedidoMapaCotacaoAsync,
  enviarEmailComAnexoAsync,
} from "../../../services/mapaCotacaoService";
import { mapState, mapActions } from "vuex";
import { normalizeTextUppercase } from "../../../utils";
import Solicitacao from "./Solicitacao.vue";
import Fornecedor from "./Fornecedor.vue";
import EmailComposer from "./EmailComposer.vue";
import CadastroFornecedor from "../../../components/Cadastro/Fornecedor/Criar.vue";
import EditaFornecedor from "../../../components/Cadastro/Fornecedor/Editar.vue";
import MapaCotacaoZoomControls from "./MapaCotacaoZoomControls.vue";
import { getUserPermission, getUserRoles } from "@/services/loginService";
import { saveAs } from "file-saver";
import valoresMonetariosMixin from "./valoresMonetariosMixin";
import mapaCotacaoZoomMixin from "./mapaCotacaoZoomMixin";

export default {
  name: "criarMapa",
  mixins: [valoresMonetariosMixin, mapaCotacaoZoomMixin],
  data: () => ({
    tipo: "N",
    overlay: false,
    valid: true,
    produtosVisiveisMobile: true,
    descricao: null,
    observacao: null,
    localSelected: null,
    unidadeAdmSelected: null,
    produtosL: [],
    fornecedorL: [],
    indexEdit: null,
    read_only: false,
    status_pedido: false,
    showModalProduto: false,
    showModalFornecedor: false,
    showModalCadastroFornecedor: false,
    showModalEditaFornecedor: false,
    showEmailModal: false,
    showModalInativarItem: false,
    produtoInativacao: null,
    justificativaInativacaoItem: '',
    errorMessage: false,
    errorMessageValue: null,
    informacoesAdicionais: "",
    localSelecionado: null,
    produtosSelecionados: [],
    fornecedoresSelecionados: [],
    condicoesPagamento: [],
    itensPreenchidos: [],
    rules: {
      naoNegativo: (v) =>
        v === null ||
        v === "" ||
        Number(String(v).replace(",", ".")) >= 0 ||
        "Não pode ser negativo", // Adicionado v === "" para campos vazios
      descontoNaoDeixaTotalNegativo:
        (fornecedorId, idSolicitacaoItem, produtoId) => (value) => {
          const item = this.getItem(fornecedorId, idSolicitacaoItem, produtoId);
          const valorUnitario = parseFloat(item.valor) || 0;
          const descontoAplicado =
            parseFloat(String(value).replace(",", ".")) || 0;
          const produtoOriginal = this.produtosL.find(
            (p) => p.idProduto === produtoId
          );
          const quantidade = produtoOriginal?.quantidadeAutorizado || 1;

          // O cálculo do total do item é (valor * quantidade) - desconto
          // Queremos garantir que (valor * quantidade) - desconto >= 0
          if (valorUnitario * quantidade - descontoAplicado < 0) {
            return "Desconto não pode tornar o total do item negativo.";
          }
          return true;
        },
    },
  }),
  computed: {
    ...mapState("local", ["locais"]),
    ...mapState("mapaCotacao", ["mapaCotacao"]),
    ...mapState("condicaoPagamento", ["condicoes"]),
    ...mapState("fornecedor", ["fornecedor", "fornecedores"]),
    ...mapState("solicitacao", ["produtosSolicitacao"]),
    filteredLocal() {
      return this.locais.filter((lc) => {
        return (
          (lc.idTipoLocais === 1 || lc.idTipoLocais === 3) && lc.ativo === true
        );
      });
    },
    filteredUnidAdm() {
      return this.locais.filter((lc) => {
        return (
          (lc.idTipoLocais === 2 || lc.idTipoLocais === 3) && lc.ativo === true
        );
      });
    },
    podeGerarPedido() {
      if (this.mapaCotacao.status === "AA") {
        return false;
      }
      if (!this.produtosL || !this.fornecedorL) {
        return false;
      }
      if (this.produtosL.length <= 0 || this.fornecedorL.length <= 0) {
        return false;
      }
      const produtosUnicos = [
        ...new Set(this.itensPreenchidos.map((item) => item.idSolicitacaoItem)),
      ];
      return produtosUnicos.some((idSolicitacaoItem) => {
        return this.itensPreenchidos.some(
          (item) => item.idSolicitacaoItem === idSolicitacaoItem && item.comprar
        );
      });
    },
  },
  methods: {
    ...mapActions("solicitacao", ["atualizarProdutosCotacao"]),
    ...mapActions("pedido", ["atualizarPedidos"]),
    ...mapActions("mapaCotacao", ["updateMapaCotacao"]),
    ...mapActions("fornecedor", [
      "atualizarFornecedores",
      "atualizarFornecedor",
    ]),
    async enviar() {
      let validacao = true;
      this.produtosL.forEach((p) => {
        let total = 0;
        this.fornecedorL.forEach((f) => {
          const item = this.getItem(
            f.idFornecedor,
            p.idSolicitacaoItem,
            p.idProduto
          );
          if (item.comprar === true) {
            total += item.quantidade;
          }
          if (
            item.quantidade < 0 ||
            item.descontoProduto < 0 ||
            f.acrescimo < 0 ||
            f.descontoTotal < 0
          ) {
            this.$alert(
              "O quantidade no produto " +
                p.produto +
                " do fornecedor " +
                f.nome +
                " possui valores negativos. Operação cancelada",
              "Erro!",
              "error"
            );
            validacao = false;
            return;
          }
        });
        if (total > p.quantidadeAutorizado) {
          this.$alert(
            "A soma da quantidade execedeu o limite solicitado. Produto: " +
              p.produto +
              ". Quantidade solicitado: " +
              p.quantidadeAutorizado +
              ". Total somado: " +
              total +
              ". Operação cancelada",
            "Erro!",
            "error"
          );
          validacao = false;
          return;
        }
      });
      if (validacao) {
        if (this.produtosL == null || this.produtosL.length <= 0) {
          this.errorMessageValue = "Adicione os produtos mapa!";
          this.errorMessage = true;
          return;
        } else if (this.fornecedorL == null || this.fornecedorL.length <= 0) {
          this.errorMessageValue = "Adicione os fornecedores mapa!";
          this.errorMessage = true;
          return;
        } else {
          this.overlay = true;
          const payload = this.montarPayload();

          const resposta = await atualizarMapaCotacaoAsync(payload);
          try {
            if (!resposta || resposta?.status != 200) {
              // Ajuste para verificar se a resposta é nula ou falha
              this.$alert(
                resposta?.message ||
                  "Ocorreu um erro ao enviar o mapa de cotação.", // Mensagem de erro mais robusta
                "Desculpe, falha na operação!",
                "error"
              );
            } else {
              this.updateMapaCotacao(resposta.data);

              this.$store.dispatch("ui/showSnackbar", {
                text: "Atualizado com sucesso!",
                color: "success",
                timeout: 3000,
              });
              //this.$router.push("/mapaCotacao");
            }
          } finally {
            this.overlay = false;
          }
        }
      }
    },

    addProduto: function () {
      this.showModalProduto = true;
    },
    addFornecedor: function () {
      this.showModalFornecedor = true;
    },
    abrirEmail: function () {
      this.showEmailModal = true;
    },
    disable(value) {
      return (
        Object.prototype.toString.call(value) === "[object Array]" &&
        !(JSON.stringify(value) === "[]")
      );
    },
    removeProduto(index) {
      // Remover o produto do array principal
      const idSolicitacaoItemRemovido = this.produtosL[index].idSolicitacaoItem;
      this.produtosL.splice(index, 1);

      // Remover os itens preenchidos relacionados a este produto
      this.itensPreenchidos = this.itensPreenchidos.filter(
        (item) => item.idSolicitacaoItem !== idSolicitacaoItemRemovido
      );
    },
    abrirModalInativarProduto(index) {
      const produto = this.produtosL[index];
      if (!produto || produto.possuiPedidoAtivo) {
        this.$alert(
          "Este item possui Pedido de Compra ativo vinculado e não pode ser inativado.",
          "Atenção!",
          "warning"
        );
        return;
      }
      this.produtoInativacao = produto;
      this.justificativaInativacaoItem = "";
      this.showModalInativarItem = true;
    },
    fecharModalInativarItem() {
      this.showModalInativarItem = false;
      this.produtoInativacao = null;
      this.justificativaInativacaoItem = "";
    },
    async confirmarInativarItem() {
      const justificativa = (this.justificativaInativacaoItem || "").trim();
      if (!justificativa) {
        this.$alert("Informe a justificativa para inativar o item.", "Atenção!", "warning");
        return;
      }
      if (!this.produtoInativacao) {
        return;
      }

      this.overlay = true;
      try {
        const resposta = await inativarItemMapaCotacaoAsync(
          this.mapaCotacao.id,
          this.produtoInativacao.idSolicitacaoItem,
          justificativa
        );

        if (!resposta || resposta?.status != 200) {
          this.$alert(
            resposta?.message || "Não foi possível inativar o item do Mapa de Cotação.",
            "Desculpe, falha na operação!",
            "error"
          );
          return;
        }

        this.updateMapaCotacao(resposta.data);
        this.produtosL = [];
        this.fornecedorL = [];
        this.itensPreenchidos = [];
        this.carregarMapaCotacao(resposta.data);
        this.read_only = resposta.data?.status === "I" ? true : this.read_only;
        this.fecharModalInativarItem();
        this.$store.dispatch("ui/showSnackbar", {
          text: "Item inativado com sucesso!",
          color: "success",
          timeout: 3000,
        });
      } finally {
        this.overlay = false;
      }
    },
    editaProduto(index) {
      this.indexEdit = index;
      this.showModalProduto = true;
    },
    changeProduto(index, centroCusto) {
      this.produtosL[index].idCentroCusto = centroCusto.id;
      this.produtosL[index].centroCusto = centroCusto.descricao;
    },
    updateProduto() {
      var produto = this.produtosL.filter((p) => p.index === this.indexEdit);
      this.$refs.editprd.updateObject2(produto[0]);
    },
    async gerarPedido() {
      if (!this.$refs.form.validate()) {
        this.errorMessageValue =
          "Preencha todos os campos obrigatórios e corrija os erros.";
        this.errorMessage = true;
        return;
      }
      const fornecedorSemDestino = this.fornecedorL.find((fornecedor) => {
        const possuiItemComprado = this.itensPreenchidos.some(
          (item) =>
            item.idFornecedor === fornecedor.idFornecedor && item.comprar
        );

        return (
          possuiItemComprado &&
          (fornecedor.coleta
            ? !fornecedor.enderecoColeta ||
              !fornecedor.enderecoColeta.trim()
            : !fornecedor.idLocalEntrega)
        );
      });

      if (fornecedorSemDestino) {
        this.$alert(
          `Informe o ${
            fornecedorSemDestino.coleta
              ? "endereço de coleta"
              : "local de entrega"
          } do fornecedor ${fornecedorSemDestino.nome}.`,
          "Mapa incompleto",
          "warning"
        );
        return;
      }

      let validacao = true;
      this.produtosL.forEach((p) => {
        let total = 0;
        this.fornecedorL.forEach((f) => {
          const item = this.getItem(
            f.idFornecedor,
            p.idSolicitacaoItem,
            p.idProduto
          );
          if (item.comprar === true) {
            total += item.quantidade;
            if (item.total <= 0) {
              this.$alert(
                "O valor total no produto " +
                  p.produto +
                  " do fornecedor " +
                  f.nome +
                  " está zerado. Operação cancelada",
                "Erro!",
                "error"
              );
              validacao = false;
              return;
            }
          }
        });
        if (total > p.quantidadeAutorizado) {
          this.$alert(
            "A soma da quantidade execedeu o limite solicitado. Produto: " +
              p.produto +
              ". Quantidade solicitado: " +
              p.quantidadeAutorizado +
              ". Total somado: " +
              total +
              ". Operação cancelada",
            "Erro!",
            "error"
          );
          validacao = false;
          return;
        }
      });
      if (validacao) {
        this.overlay = true;
        try {
          const payload = this.montarPayload();

          const resposta = await gerarPedidoMapaCotacaoAsync(payload);
          if (!resposta || resposta?.status != 200) {
            // Ajuste para verificar se a resposta é nula ou falha
            this.$alert(
              resposta?.message ||
                "Ocorreu um erro ao enviar o mapa de cotação.", // Mensagem de erro mais robusta
              "Desculpe, falha na operação!",
              "error"
            );
          } else {
            if (resposta.data.status == "AA") {
              this.$alert(
                "O valor total atingiu o limite permitido. Será necessário a análise pelo gestor.",
                "Atenção!",
                "warning"
              );
            } else {
              this.$store.dispatch("ui/showSnackbar", {
                text: "Pedido gerado com sucesso!",
                color: "success",
                timeout: 3000,
              });
            }
            this.updateMapaCotacao(resposta.data);
            this.atualizarPedidos();
            this.$router.push("/mapaCotacao");
          }
        } finally {
          this.overlay = false;
        }
      }
    },

    atualizar: function (e) {
      var produtoValido = this.$refs.editprd.updateObjectEstate();
      if (!produtoValido) {
        e.preventDefault();
        this.errorMessageValue = "Informe a quantidade!";
        this.errorMessage = true;
        return;
      }
      this.produtosL[this.indexEdit].quantidade = this.$refs.editprd.quantidade;
      this.produtosL[this.indexEdit].observacao = this.$refs.editprd.observacao;
      this.showModalProduto = false;
    },
    async obterListas() {
      //await this.atualizarProdutosCotacao();
      //await this.atualizarFornecedores();
    },

    changeLocal(idFornecedor) {
      let item = this.fornecedorL.find((i) => i.idFornecedor === idFornecedor);
      if (item) {
        if (this.fornecedorL[item.index].coleta == false) {
          this.fornecedorL[item.index].enderecoColeta = null;
        } else {
          if (item.endereco == null) {
            let fornecedor = this.fornecedores.find(
              (i) => i.id === idFornecedor
            );
            if (fornecedor) {
              item.endereco =
                fornecedor.endereco +
                ", " +
                fornecedor.numero +
                " Bairro: " +
                fornecedor.bairro +
                ". Cidade: " +
                fornecedor.cidade +
                "/" +
                fornecedor.uf +
                " CEP:" +
                fornecedor.cep;
            }
          }
          this.fornecedorL[item.index].idLocalEntrega = null;
          this.fornecedorL[item.index].enderecoColeta = normalizeTextUppercase(item.endereco);
        }
      }
      return item;
    },
    getItem(idFornecedor, idSolicitacaoItem, idProduto) {
      let item = this.itensPreenchidos.find(
        (i) =>
          i.idFornecedor === idFornecedor &&
          i.idSolicitacaoItem === idSolicitacaoItem
      );

      if (!item) {
        item = {
          id: 0,
          idFornecedor,
          idSolicitacaoItem,
          idProduto, // mantém para payload/uso futuro
          marca: "",
          prazo: 0,
          valor: 0,
          quantidade: 0,
          descontoProduto: 0,
          total: 0,
        };
        this.itensPreenchidos.push(item);
      }

      return item;
    },
    calcularTotais(idFornecedor, idSolicitacaoItem) {
      const item = this.getItem(idFornecedor, idSolicitacaoItem);

      const valorUnitario = parseFloat(item.valor) || 0;
      const descontoAplicado = parseFloat(item.descontoProduto) || 0;
      const quantidade = parseFloat(item.quantidade) || 0;

      let totalCalculado = valorUnitario * quantidade - descontoAplicado;
      item.total = totalCalculado < 0 ? 0 : this.arredondarDecimal(totalCalculado);
    },
    calcularSubtotal(idFornecedor) {
      const subtotal = this.itensPreenchidos
        .filter((i) => i.idFornecedor === idFornecedor && i.comprar == true)
        .reduce((sum, i) => sum + (i.total || 0), 0); // Garante que i.total seja numérico
      return this.arredondarDecimal(subtotal);
    },
    calcularDescontoTotal(idFornecedor) {
      // Este método deve calcular o total dos DESCONTOS aplicados por item
      return this.itensPreenchidos
        .filter((i) => i.idFornecedor === idFornecedor)
        .reduce((sum, i) => sum + (parseFloat(i.descontoProduto) || 0), 0);
    },
    calcularTotalFinal(idFornecedor) {
      const subtotal = this.calcularSubtotal(idFornecedor);
      // O desconto já está subtraído no total de cada item (subtotal).
      // Agora, apenas adicionamos o acréscimo.
      const acrescimo =
        this.fornecedorL.find((f) => f.idFornecedor === idFornecedor)
          ?.acrescimo || 0;

      const desconto =
        this.fornecedorL.find((f) => f.idFornecedor === idFornecedor)
          ?.descontoTotal || 0;

      let totalFinal = subtotal + parseFloat(acrescimo) - desconto;

      // Garante que o total final do fornecedor não seja negativo
      if (totalFinal < 0) {
        totalFinal = 0;
      }
      return this.arredondarDecimal(totalFinal);
    },
    // O método removerProduto já foi ajustado acima para também remover de itensPreenchidos
    removerProduto(index) {
      this.produtosL.splice(index, 1);
    },
    excluirFornecedor(index) {
      this.fornecedorL.splice(index, 1);
    },
    abrirCadastroProduto() {
      this.showModalCadastroFornecedor = true;
    },
    obterIdMapaCotacaoItem(fornecedorId, idSolicitacaoItem, produtoId) {
      const itemPayload = this.itensPreenchidos.find(
        (i) =>
          i.idFornecedor === fornecedorId &&
          i.idSolicitacaoItem === idSolicitacaoItem &&
          i.idProduto === produtoId
      );

      if (itemPayload?.id) {
        return itemPayload.id;
      }

      const itemMapa = this.mapaCotacao?.itens?.find(
        (i) =>
          i.idFornecedor === fornecedorId &&
          i.idSolicitacaoItem === idSolicitacaoItem &&
          i.idProduto === produtoId
      );

      return itemMapa?.id || 0;
    },
    montarPayload() {
      const mapaCotacaoItens = this.fornecedorL
        .map((fornecedor) => {
          return this.produtosL.map((produto) => {
            const dadosItem =
              this.itensPreenchidos.find(
                (i) =>
                  i.idFornecedor === fornecedor.idFornecedor &&
                  i.idSolicitacaoItem === produto.idSolicitacaoItem
              ) || {};

            return {
              id: this.obterIdMapaCotacaoItem(
                fornecedor.idFornecedor,
                produto.idSolicitacaoItem,
                produto.idProduto
              ),
              idSolicitacaoItem: produto.idSolicitacaoItem,
              idProduto: produto.idProduto,
              quantidadeAutorizado: produto.quantidadeAutorizado,
              idFornecedor: fornecedor.idFornecedor,
              nomeOrcamento: fornecedor.nomeOrcamento,
              idCondicaoPagamento: fornecedor.idCondicaoPagamento || 0,
              coleta: fornecedor.coleta || false,
              enderecoColeta: fornecedor.enderecoColeta || "",
              idLocalEntrega: fornecedor.idLocalEntrega || 0,
              prazoEntrega: dadosItem.prazo || 0,
              marca: dadosItem.marca || "",
              quantidade: this.normalizarNumeroPayload(dadosItem.quantidade),
              valor: this.normalizarNumeroPayload(dadosItem.valor),
              descontoProduto: this.normalizarNumeroPayload(dadosItem.descontoProduto),
              acrescimo: this.normalizarNumeroPayload(fornecedor.acrescimo),
              descontoTotal: this.normalizarNumeroPayload(fornecedor.descontoTotal),
              // O subtotal aqui deve ser o total do item individual, não o subtotal geral do fornecedor
              // Se o backend espera o subtotal por item, ajuste aqui.
              // Caso contrário, você pode remover ou deixar 0 se for calculado no backend.
              subtotal: this.normalizarNumeroPayload(dadosItem.total),
              observacao: fornecedor.observacao || "",
              total: this.normalizarNumeroPayload(dadosItem.total), // Este é o total do ITEM
              comprar: dadosItem.comprar || false,
            };
          });
        })
        .flat();

      const payload = {
        id: this.mapaCotacao.id,
        autorizado: this.mapaCotacao.autorizado,
        informacoesAdicionais: this.informacoesAdicionais,
        itens: mapaCotacaoItens,
      };

      return payload;
    },

    carregarMapaCotacao(mapa) {
      if (!mapa || !mapa.itens || mapa.itens.length === 0) {
        return;
      }

      this.informacoesAdicionais = mapa.informacoesAdicionais || "";

      mapa.itens.forEach((item) => {
        const produtoExiste = this.produtosL.some(
          (p) => p.idSolicitacaoItem === item.idSolicitacaoItem
        );
        if (produtoExiste) {
          const produto = this.produtosL.find(
            (p) => p.idSolicitacaoItem === item.idSolicitacaoItem
          );
          if (produto) {
            produto.possuiPedidoAtivo = produto.possuiPedidoAtivo || item.possuiPedidoAtivo === true;
          }
        }
        if (!produtoExiste) {
          const produto = {
            id: item.id,
            idSolicitacaoItem: item.idSolicitacaoItem,
            idProduto: item.idProduto,
            idSolicitacao: item.idSolicitacao,
            quantidadeAutorizado: item.quantidadeSolicitacao,
            produto: item.produto,
            codigo: item.codigo,
            centroCusto: item.centroCusto,
            unidadeMedida: item.unidadeMedida,
            unidadeAdm: item.unidadeAdm,
            departamento: item.departamento,
            possuiPedidoAtivo: item.possuiPedidoAtivo === true,
            index:
              this.produtosL.length === 0
                ? 0
                : Math.max(...this.produtosL.map((p) => p.index)) + 1, // Garante index único
          };
          this.produtosL.push(produto);
        }

        // Verifica se fornecedor já foi adicionado
        const fornecedorExiste = this.fornecedorL.some(
          (f) => f.idFornecedor === item.idFornecedor
        );
        if (!fornecedorExiste) {
          const fornecedor = {
            idFornecedor: item.idFornecedor,
            idCondicaoPagamento: item.idCondicaoPagamento,
            coleta: item.coleta,
            idLocalEntrega: item.idLocalEntrega,
            enderecoColeta: item.enderecoColeta,
            nomeOrcamento: item.nomeOrcamento,
            nome: item.nomeFornecedor,
            emails: item.emailsFornecedor,
            contato: item.contatoFornecedor,
            telefone: item.telefoneFornecedor,
            acrescimo: item.acrescimo,
            descontoTotal: item.descontoTotal,
            observacao: item.observacaoFornecedor || "", // Adicionado observacao do fornecedor
            index:
              this.fornecedorL.length === 0
                ? 0
                : Math.max(...this.fornecedorL.map((f) => f.index)) + 1, // Garante index único
          };
          this.fornecedorL.push(fornecedor);
        }

        // Sempre adiciona o item preenchido (relacionamento produto-fornecedor)
        // Certifique-se de que não há duplicatas de itensPreenchidos se carregarMapaCotacao for chamado múltiplas vezes
        const itemPreenchidoExiste = this.itensPreenchidos.some(
          (i) =>
            i.idFornecedor === item.idFornecedor &&
            i.idSolicitacaoItem === item.idSolicitacaoItem
        );

        if (!itemPreenchidoExiste) {
          this.itensPreenchidos.push({
            id: item.id,
            idFornecedor: item.idFornecedor,
            idSolicitacaoItem: item.idSolicitacaoItem,
            idProduto: item.idProduto, // mantém para payload/relatórios
            marca: item.marca || "",
            prazo: item.prazoEntrega || 0,
            quantidade: item.quantidade || 0,
            valor: item.valor || 0,
            descontoProduto: item.descontoProduto || 0,
            total: item.total || 0,
            comprar: item.comprar,
          });
        }
      });
      // Após carregar, recalculamos todos os totais para garantir a consistência
      this.fornecedorL.forEach((f) => {
        this.produtosL.forEach((p) => {
          this.calcularTotais(f.idFornecedor, p.idSolicitacaoItem);
        });
      });
    },
    marcarCompraExclusiva(idFornecedor, idSolicitacaoItem, quantidadeLinha) {
      let total = 0;

      this.fornecedorL.forEach((fornecedor) => {
        const item = this.getItem(fornecedor.idFornecedor, idSolicitacaoItem);
        if (item.comprar === true) {
          total += parseFloat(item.quantidade) || 0;
        }
      });

      if (total > quantidadeLinha) {
        const produtoNome = this.produtosL.find(
          (p) => p.idSolicitacaoItem === idSolicitacaoItem
        )?.produto;

        this.$alert(
          "A soma da quantidade excedeu o limite solicitado. Produto: " +
            produtoNome +
            ". Quantidade solicitada: " +
            quantidadeLinha +
            ". Total somado: " +
            total,
          "Atenção!",
          "warning"
        );
      }
    },
    editFornecedor(item) {
      this.atualizarFornecedor(item);
      this.showModalEditaFornecedor = false; // fecha antes
      this.$nextTick(() => {
        this.showModalEditaFornecedor = true; // reabre com novo key
      });
    },
    formatarLocal(local) {
      return `${local.descricao} (${local.logradouro}, nº ${local.numeroDoLocal} ${local.cidade})`;
    },

    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    async enviarEmail(formData) {
      this.overlay = true;
      const resposta = await enviarEmailComAnexoAsync(formData);

      if (resposta == null || resposta.success === false) {
        this.overlay = false;
        this.$alert(resposta.message, "Descupe, falha na operação!", "error");
      } else {
        this.overlay = false;
        this.$alert("Email enviado!", "", "success");
      }
    },
    anexaExcel() {
      const blob = this.gerarExcel();
      return new File([blob], "Cotacao Nº" + this.mapaCotacao.id + ".xlsx", {
        type: blob.type,
      });
    },
    exportarExcel() {
      const blob = this.gerarExcel();
      const nome_arquivo = "Cotacao Nº" + this.mapaCotacao.id + ".xlsx";
      saveAs(blob, nome_arquivo);
    },
    gerarExcel() {
      const colunas = [
        { chave: "produto", cabecalho: "ITEM" },
        { chave: "codigo", cabecalho: "CODIGO" },
        { chave: "unidadeMedida", cabecalho: "UN" },
        { chave: "quantidadeAutorizado", cabecalho: "QUANTIDADE" },
        { chave: "", cabecalho: "MARCA" },
        { chave: "", cabecalho: "VALOR UNITARIO" },
        { chave: "", cabecalho: "PRAZO De ENTREGA" },
        { chave: "", cabecalho: "CONDIÇÃO DE PAGTO" },
      ];

      // Cria array com primeira linha como cabeçalho e as demais com os dados
      const aoa = [];

      // Linha de cabeçalhos (com nomes bonitos)
      aoa.push(colunas.map((c) => c.cabecalho));

      // Demais linhas (dados filtrados e na ordem)
      this.produtosL.forEach((item) => {
        aoa.push(colunas.map((c) => item[c.chave]));
      });

      // Cria a planilha
      const ws = window.XLSX.utils.aoa_to_sheet(aoa);

      const larguras = colunas.map((col) => {
        const valores = [
          col.cabecalho,
          ...this.produtosL.map((d) => String(d[col.chave])),
        ];
        const larguraMaxima = Math.max(...valores.map((v) => v.length)) + 2;
        return { wch: larguraMaxima };
      });
      ws["!cols"] = larguras;

      const headerStyle = {
        font: { bold: true },
        alignment: { horizontal: "center" },
      };
      colunas.forEach((col, index) => {
        const colLetra = String.fromCharCode(65 + index); // A, B, C...
        const cell = ws[`${colLetra}1`];
        if (cell) cell.s = headerStyle;
      });
      const wb = window.XLSX.utils.book_new();
      window.XLSX.utils.book_append_sheet(wb, ws, "Planilha");

      // Escreve o arquivo em memória (array buffer)
      const wbout = window.XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
        cellStyles: true,
      });

      // Retorna como Blob
      return new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    },
  },
  created: function () {
    this.obterListas();
    this.carregarMapaCotacao(this.mapaCotacao);
    this.read_only =
      !getUserPermission(10) ||
      (this.mapaCotacao.status != "PC" &&
        this.mapaCotacao.status != "AA" &&
        this.mapaCotacao.status != "D" &&
        this.mapaCotacao.status != "PG" &&
        this.mapaCotacao.status != "PP");
    this.status_pedido =
      !getUserPermission(10) ||
      (this.mapaCotacao.status != "PC" &&
        this.mapaCotacao.status != "AG" &&
        this.mapaCotacao.status != "D" &&
        this.mapaCotacao.status != "PP" &&
        this.mapaCotacao.status != "PG");
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
  watch: {
    showModalProduto(visible) {
      if (visible && this.indexEdit !== null) {
        if (
          this.$refs.editprd &&
          typeof this.$refs.editprd.updateObject2 === "function"
        ) {
          this.updateProduto();
        }
      }
    }
  },
  components: {
    Solicitacao,
    Fornecedor,
    CadastroFornecedor,
    EditaFornecedor,
    EmailComposer,
    MapaCotacaoZoomControls,
  },
};
</script>

<style scoped>
.mapa-cotacao-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}

.mapa-cotacao-actions .v-btn {
  margin: 0;
}

.mapa-cotacao-modal-card {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.mapa-cotacao-modal-title {
  flex-wrap: wrap;
  gap: 8px;
}

.mapa-cotacao-modal-body {
  flex: 1 1 auto;
  overflow-y: auto;
}

.mapa-cotacao-modal-actions {
  position: sticky;
  bottom: 0;
  z-index: 1;
  background: #fff;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 768px) {
  .mapa-cotacao-actions {
    display: grid;
    grid-template-columns: 1fr;
    justify-content: stretch;
  }

  .mapa-cotacao-actions .v-btn {
    width: 100%;
    max-width: 100%;
    white-space: normal;
  }

  .mapa-cotacao-modal-card {
    max-height: 92vh;
  }

  .mapa-cotacao-modal-body {
    padding: 12px !important;
  }

  .mapa-cotacao-modal-actions .v-btn {
    width: 100%;
    margin: 0 !important;
  }
}

/* Reset de margens e paddings padrão do Vuetify para inputs */
.v-text-field,
.v-select,
.v-textarea {
  margin: 0 !important;
  padding: 0 !important;
}

.v-input__control,
.v-input__slot {
  min-height: unset !important; /* Remover altura mínima padrão */
  padding: 0 !important; /* Remover padding padrão */
}

/* Estilos para deixar os inputs mais compactos */
.compact-input .v-input__control,
.compact-input .v-input__slot {
  min-height: 28px !important; /* Altura menor para inputs */
  max-height: 28px !important;
  display: flex; /* Para alinhar o conteúdo */
  align-items: center; /* Centraliza verticalmente o texto/valor */
}

.compact-input input {
  font-size: 0.8rem !important; /* Reduz o tamanho da fonte */
  padding: 4px 8px !important; /* Ajusta padding interno */
}

.compact-textarea .v-input__control,
.compact-textarea .v-input__slot {
  min-height: 50px !important; /* Altura menor para textarea */
  max-height: 50px !important;
}

.compact-textarea textarea {
  font-size: 0.8rem !important; /* Reduz o tamanho da fonte */
  padding: 4px 8px !important; /* Ajusta padding interno */
}

/* --- ESTILOS EXISTENTES --- */
.produto-cabecalho {
  background-color: #1976d2;
  color: white;
  font-weight: bold;
  font-size: 13px;
  text-align: center;
}
.fornecedor-nome {
  font-weight: bold;
  text-align: center;
  margin-bottom: 6px;
}
/* Estilos globais para flexbox e containers */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cotacao-tabela-container {
  overflow-x: auto; /* Permite o scroll horizontal quando o conteúdo exceder */
  width: 100%;
}

.cotacao-tabela {
  width: 100%;
  border-collapse: collapse; /* Garante que as bordas das células se unam */
}

/* Estilos de célula e cabeçalho padrão da tabela */
.cotacao-tabela th,
.cotacao-tabela td {
  padding: 4px; /* Ajuste o padding conforme necessário para compactar */
  border: 1px solid #ddd; /* Adiciona bordas para visualização clara da tabela */
  vertical-align: top; /* Alinha o conteúdo ao topo da célula */
  text-align: left; /* Alinhamento padrão do texto */
  /* white-space: nowrap; /* Desativado para permitir quebra de linha em nomes de produto/fornecedor se necessário */
}

/* Estilos de cabeçalho principal (Cotação X) */
.cotacao-cabecalho {
  background-color: #1976d2;
  color: white;
  font-weight: bold;
  font-size: 16px;
  position: sticky;
  top: 0;
  z-index: 2; /* Garante que o cabeçalho esteja acima do conteúdo */
  padding: 8px; /* Padding padrão para cabeçalhos */
}

/* Estilo para a célula vazia superior esquerda (cabeçalho da coluna fixa) */
.fixed-column-header.top-header {
  background-color: #1976d2; /* Cor de fundo igual aos cabeçalhos principais */
  color: white;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 4; /* Maior z-index para ficar acima de tudo no canto */
  width: 300px; /* Largura da coluna fixa, ajustável */
  min-width: 300px;
  max-width: 300px;
}

/* Cabeçalho dos detalhes do produto (Ação, Produto, Qtd) na coluna fixa */
.fixed-column-header.product-details-header {
  background-color: #1976d2; /* Cor de fundo igual */
  color: white;
  font-weight: bold;
  font-size: 13px;
  position: sticky;
  left: 0;
  top: 48px; /* Abaixo do cabeçalho "Cotação X" */
  z-index: 3; /* Z-index para ficar acima das colunas que rolam */
  padding: 0; /* Remove padding da célula th */
  width: 300px; /* Largura da coluna fixa, deve ser a mesma de top-header */
  min-width: 300px;
  max-width: 300px;
}

.product-header-content {
  display: grid;
  grid-template-columns: 50px 1fr 60px; /* Ação, Produto, Qtd */
  gap: 4px; /* Espaçamento entre os labels */
  padding: 8px; /* Padding interno */
  align-items: center;
  height: 100%;
}

.product-header-content span {
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis; /* Adiciona reticências se o texto for muito longo */
  white-space: nowrap; /* Garante que o texto não quebre linha */
}

.product-header-content .product-label {
  text-align: left; /* Alinhar o label "Produto" à esquerda */
}

/* Cabeçalho dos detalhes do fornecedor (Prazo, Marca, etc.) */
.fornecedor-detail-header {
  background-color: #1976d2;
  color: white;
  font-weight: bold;
  font-size: 13px;
  position: sticky;
  top: 48px; /* Abaixo do cabeçalho "Cotação X" */
  z-index: 2; /* Para ficar abaixo da coluna fixa */
  padding: 0; /* Controlado pelo inner div */
}

.fornecedor-detail-labels-inner {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 5 colunas de tamanho igual */
  gap: 4px; /* Espaçamento entre as colunas */
  padding: 8px; /* Padding interno */
  height: 100%; /* Ocupa toda a altura do cabeçalho */
  align-items: center;
}

.fornecedor-detail-labels-inner span {
  font-size: 0.75rem;
  font-weight: bold;
  text-align: center;
  color: white; /* Cor do texto do cabeçalho */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Coluna Fixa (Ação, Produto, Qtd) para as linhas de dados */
.fixed-column {
  position: sticky;
  left: 0;
  background-color: #f5f5f5; /* Cor de fundo para a coluna fixa */
  z-index: 1; /* Garante que a coluna fixa esteja acima do scroll */
  width: 300px; /* Mesma largura do cabeçalho */
  min-width: 300px;
  max-width: 300px;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1); /* Sombra para destacar a coluna fixa */
  padding: 0; /* Padding controlado internamente */
}

.info-adicional-cell {
  padding: 8px; /* Padding para o textarea */
}

.product-item-cell {
  padding: 0; /* Padding interno */
}

.product-item-content {
  display: grid;
  grid-template-columns: 50px 1fr 60px; /* Ação, Produto, Qtd - mesmo layout do cabeçalho */
  gap: 4px;
  padding: 8px;
  align-items: center;
  height: 100%; /* Ocupa a altura total da linha */
  box-sizing: border-box; /* Inclui padding na altura total */
}

.product-name-display {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis; /* Adiciona reticências */
  white-space: nowrap; /* Tenta manter o nome na mesma linha */
  font-size: 0.85rem;
}

.product-quantity-display {
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
}

.remove-btn {
  flex-shrink: 0; /* Não permite que o botão diminua */
}

/* Células de dados dos fornecedores (inputs) */
.fornecedor-item-data-cell {
  padding: 4px; /* Padding padrão para a célula td */
}

.fornecedor-inputs-row-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 5 colunas para os 5 inputs */
  gap: 4px; /* Espaçamento entre os inputs */
  height: 100%; /* Ocupa a altura total da célula */
  align-items: center; /* Alinha verticalmente os inputs */
}

/* Ajustes para v-text-field e v-select dentro das células */
.fornecedor-item-data-cell .v-text-field,
.fornecedor-item-data-cell .v-select {
  margin: 0 !important; /* Remove margens padrão do Vuetify */
  padding: 0 !important; /* Remove paddings padrão do Vuetify */
  min-height: unset !important; /* Remover altura mínima para compactar */
  height: 100%; /* Faz com que o input ocupe a altura disponível */
}

.fornecedor-item-data-cell .v-input__control,
.fornecedor-item-data-cell .v-input__slot {
  min-height: 30px !important; /* Altura padrão mais compacta */
  padding: 0 4px !important; /* Padding interno mais compacto */
}

.fornecedor-item-data-cell .v-text-field input {
  text-align: center; /* Centraliza o texto dentro do input */
  font-size: 0.8rem; /* Tamanho da fonte menor para compactar */
}

.fornecedor-item-data-cell .v-text-field input::placeholder {
  font-size: 0.7rem;
  text-align: center;
  color: #777;
}

/* Linha 4: Totais e observações */
.fornecedor-totals-section {
  display: flex; /* Usar flexbox para os itens */
  justify-content: space-around; /* Distribui o espaço entre os itens */
  align-items: flex-start; /* Alinha os itens ao topo */
  gap: 8px; /* Espaçamento entre os elementos */
  padding: 8px; /* Padding interno */
  flex-wrap: wrap; /* Permite que os itens quebrem linha se não houver espaço */
}

.fornecedor-totals-section .total-field {
  display: flex;
  flex-direction: column;
  align-items: center; /* Centraliza o label e o input */
  white-space: nowrap;
  flex: 1 1 auto; /* Permite que os itens cresçam e diminuam */
  min-width: 100px; /* Largura mínima para cada campo de total */
}

.fornecedor-totals-section .v-text-field {
  max-width: 120px; /* Largura máxima para os inputs de total */
  width: 100%; /* Ocupa o espaço disponível */
}

.fornecedor-totals-section .v-textarea {
  flex-basis: 100%; /* Faz a textarea ocupar toda a largura */
  min-width: 100%; /* Garante que ela se estique */
}

/* Estilos para inputs gerais para compactar */
.v-text-field--outlined.v-input--dense .v-input__control,
.v-select--outlined.v-input--dense .v-input__control,
.v-textarea--outlined.v-input--dense .v-input__control {
  min-height: 36px !important; /* Altura padrão mais compacta */
}

.v-text-field--outlined.v-input--dense .v-input__slot,
.v-select--outlined.v-input--dense .v-input__slot,
.v-textarea--outlined.v-input--dense .v-input__slot {
  padding: 0 8px !important; /* Ajustar padding interno */
}
.linha-reduzida td {
  padding-top: 4px;
  padding-bottom: 4px;
}
.linha-impar {
  background-color: #ffffff;
}
.cotacao-tabela tr td > .v-simple-table {
  width: 100%;
}

.linha-par {
  background-color: #f9f9f9;
}
.col-fornecedor .v-text-field,
.col-fornecedor .v-select {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}

/* Estilos para a tabela interna dos fornecedores */
.fornecedor-inner-table {
  width: 100%;
}

.fornecedor-inner-table th,
.fornecedor-inner-table td {
  padding: 4px; /* Reduzir padding para compactar */
  height: 48px; /* Altura fixa para as células da linha de dados */
  vertical-align: middle; /* Centraliza o conteúdo verticalmente */
}

/* Larguras das colunas da tabela interna de fornecedores */
.fornecedor-inner-table .column-prazo {
  width: 10%; /* Ajuste percentual para Prazo */
  min-width: 70px;
  max-width: 80px;
}
.fornecedor-inner-table .column-marca {
  width: 25%; /* Aumenta a largura da Marca */
  min-width: 100px;
}
.fornecedor-inner-table .column-vr-unit {
  width: 15%; /* Diminui a largura de Vr. Unit */
  min-width: 80px;
}
.fornecedor-inner-table .column-desc {
  width: 10%; /* Ajuste percentual para Desc */
  min-width: 70px;
}
.fornecedor-inner-table .column-total {
  width: 20%; /* Aumenta a largura de Total */
  min-width: 80px;
}
.fornecedor-inner-table .column-checkbox {
  width: 10%; /* Ajuste percentual para o Checkbox */
  min-width: 20px;
  text-align: center; /* Centraliza o cabeçalho do checkbox */
}
.fornecedor-inner-table .column-quantidade {
  width: 15%; /* Diminui a largura de Vr. Unit */
  min-width: 80px;
}

/* Alinhamento do checkbox */
.checkbox-cell {
  display: flex;
  justify-content: center; /* Centraliza horizontalmente */
  align-items: center; /* Centraliza verticalmente */
  height: 100%; /* Ocupa a altura total da célula */
}

.align-checkbox {
  margin: 0 !important;
  padding: 0 !important;
  height: 28px !important; /* Alinha com a altura dos inputs compactos */
  min-height: 28px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Ajustes finos para os V-inputs dentro das células de fornecedor */
.col-fornecedor .v-text-field,
.col-fornecedor .v-select,
.col-fornecedor .v-checkbox {
  max-width: 100% !important; /* Garante que os inputs não ultrapassem a célula */
}
.mobile-toggle-produtos,
.mapa-mobile-layout {
  display: none;
}

@media (max-width: 768px) {
  .mobile-toggle-produtos,
  .mapa-mobile-layout {
    display: block;
  }

  .cotacao-desktop-wrapper {
    display: none;
  }

  .mapa-mobile-layout,
  .mapa-mobile-layout * {
    box-sizing: border-box;
  }

  .mapa-mobile-layout {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }

  .mapa-mobile-section,
  .mapa-fornecedor-card,
  .mapa-produto-card,
  .mapa-item-card,
  .mapa-totais-mobile,
  .mapa-info-mobile {
    width: 100%;
    max-width: 100%;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background: #fff;
    padding: 12px;
    margin-bottom: 12px;
  }

  .mapa-mobile-section-title,
  .mapa-fornecedor-title,
  .mapa-produto-title,
  .mapa-item-title {
    color: #263238;
    font-size: 0.95rem;
    font-weight: 700;
    line-height: 1.35;
    margin-bottom: 10px;
    overflow-wrap: anywhere;
  }

  .mapa-field-grid,
  .mapa-item-grid,
  .mapa-product-grid,
  .mapa-totais-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    width: 100%;
  }

  .mapa-mobile-layout .v-input,
  .mapa-mobile-layout .v-text-field,
  .mapa-mobile-layout .v-select,
  .mapa-mobile-layout .v-textarea,
  .mapa-mobile-layout .v-input__control,
  .mapa-mobile-layout .v-input__slot {
    width: 100% !important;
    max-width: 100% !important;
  }

  .mapa-mobile-layout .v-textarea textarea {
    min-height: 76px;
  }

  .mapa-mobile-label {
    color: #607d8b;
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 2px;
  }

  .mapa-mobile-value {
    color: #263238;
    font-size: 0.9rem;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  .mapa-card-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
    margin-top: 8px;
  }

  .mapa-mobile-layout .v-btn {
    max-width: 100%;
    white-space: normal;
  }
}
</style>
